'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002e$002dPage$0024$0024anon$00242 from "./io.intela.sites.intelacloud.-Page$$anon$2.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_Page$$anon$1() {
}
export { $c_Lio_intela_sites_intelacloud_Page$$anon$1 as $c_Lio_intela_sites_intelacloud_Page$$anon$1 };
$p = $c_Lio_intela_sites_intelacloud_Page$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_Page$$anon$1;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_Page$$anon$1() {
}
export { $h_Lio_intela_sites_intelacloud_Page$$anon$1 as $h_Lio_intela_sites_intelacloud_Page$$anon$1 };
$h_Lio_intela_sites_intelacloud_Page$$anon$1.prototype = $p;
$p.n2 = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($s_Lio_intela_sites_intelacloud_Page$__Home__Lio_intela_sites_intelacloud_Page(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($s_Lio_intela_sites_intelacloud_Page$__Privacy__Lio_intela_sites_intelacloud_Page(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($s_Lio_intela_sites_intelacloud_Page$__Terms__Lio_intela_sites_intelacloud_Page(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($s_Lio_intela_sites_intelacloud_Page$__Disclaimer__Lio_intela_sites_intelacloud_Page(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
});
$p.kX = (function(page) {
  var x = $s_Lio_intela_sites_intelacloud_Page$__Home__Lio_intela_sites_intelacloud_Page();
  if ((x === page)) {
    return "/";
  }
  var x$3 = $s_Lio_intela_sites_intelacloud_Page$__Privacy__Lio_intela_sites_intelacloud_Page();
  if ((x$3 === page)) {
    return "/privacy";
  }
  var x$5 = $s_Lio_intela_sites_intelacloud_Page$__Terms__Lio_intela_sites_intelacloud_Page();
  if ((x$5 === page)) {
    return "/terms";
  }
  var x$7 = $s_Lio_intela_sites_intelacloud_Page$__Disclaimer__Lio_intela_sites_intelacloud_Page();
  if ((x$7 === page)) {
    return "/disclaimer";
  }
  var x$9 = $s_Lio_intela_sites_intelacloud_Page$__NotFound__Lio_intela_sites_intelacloud_Page();
  if ((x$9 === page)) {
    return "/404";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(page);
});
$p.uE = (function(path) {
  var trimmed = (((path.length > 1) && (!(!path.endsWith("/")))) ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sc_StringOps$().xe(path, 1) : path);
  var this$2 = this.n2();
  _return: {
    var these = this$2;
    while ((!these.g())) {
      if ((this.kX(these.k()) === trimmed)) {
        var this$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(these.k());
        break _return;
      }
      these = these.i();
    }
    var this$3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
  }
  return (this$3.g() ? $s_Lio_intela_sites_intelacloud_Page$__NotFound__Lio_intela_sites_intelacloud_Page() : this$3.L());
});
var $d_Lio_intela_sites_intelacloud_Page$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_Page$$anon$1, "io.intela.sites.intelacloud.Page$$anon$1", ({
  eH: 1,
  f9: 1
}));
export { $d_Lio_intela_sites_intelacloud_Page$$anon$1 as $d_Lio_intela_sites_intelacloud_Page$$anon$1 };
function $s_Lio_intela_sites_intelacloud_Page$__Home__Lio_intela_sites_intelacloud_Page() {
  $m_Lio_intela_sites_intelacloud_Page$();
  return $t_Lio_intela_sites_intelacloud_Page$__Home;
}
export { $s_Lio_intela_sites_intelacloud_Page$__Home__Lio_intela_sites_intelacloud_Page as $s_Lio_intela_sites_intelacloud_Page$__Home__Lio_intela_sites_intelacloud_Page };
function $s_Lio_intela_sites_intelacloud_Page$__Privacy__Lio_intela_sites_intelacloud_Page() {
  $m_Lio_intela_sites_intelacloud_Page$();
  return $t_Lio_intela_sites_intelacloud_Page$__Privacy;
}
export { $s_Lio_intela_sites_intelacloud_Page$__Privacy__Lio_intela_sites_intelacloud_Page as $s_Lio_intela_sites_intelacloud_Page$__Privacy__Lio_intela_sites_intelacloud_Page };
function $s_Lio_intela_sites_intelacloud_Page$__Terms__Lio_intela_sites_intelacloud_Page() {
  $m_Lio_intela_sites_intelacloud_Page$();
  return $t_Lio_intela_sites_intelacloud_Page$__Terms;
}
export { $s_Lio_intela_sites_intelacloud_Page$__Terms__Lio_intela_sites_intelacloud_Page as $s_Lio_intela_sites_intelacloud_Page$__Terms__Lio_intela_sites_intelacloud_Page };
function $s_Lio_intela_sites_intelacloud_Page$__Disclaimer__Lio_intela_sites_intelacloud_Page() {
  $m_Lio_intela_sites_intelacloud_Page$();
  return $t_Lio_intela_sites_intelacloud_Page$__Disclaimer;
}
export { $s_Lio_intela_sites_intelacloud_Page$__Disclaimer__Lio_intela_sites_intelacloud_Page as $s_Lio_intela_sites_intelacloud_Page$__Disclaimer__Lio_intela_sites_intelacloud_Page };
function $s_Lio_intela_sites_intelacloud_Page$__NotFound__Lio_intela_sites_intelacloud_Page() {
  $m_Lio_intela_sites_intelacloud_Page$();
  return $t_Lio_intela_sites_intelacloud_Page$__NotFound;
}
export { $s_Lio_intela_sites_intelacloud_Page$__NotFound__Lio_intela_sites_intelacloud_Page as $s_Lio_intela_sites_intelacloud_Page$__NotFound__Lio_intela_sites_intelacloud_Page };
/** @constructor */
function $c_Lio_intela_sites_intelacloud_Page$() {
  this.gc = null;
  $n_Lio_intela_sites_intelacloud_Page$ = this;
  $t_Lio_intela_sites_intelacloud_Page$__Home = new $j_io$002eintela$002esites$002eintelacloud$002e$002dPage$0024$0024anon$00242.$c_Lio_intela_sites_intelacloud_Page$$anon$2("Home", 0);
  $t_Lio_intela_sites_intelacloud_Page$__Privacy = new $j_io$002eintela$002esites$002eintelacloud$002e$002dPage$0024$0024anon$00242.$c_Lio_intela_sites_intelacloud_Page$$anon$2("Privacy", 1);
  $t_Lio_intela_sites_intelacloud_Page$__Terms = new $j_io$002eintela$002esites$002eintelacloud$002e$002dPage$0024$0024anon$00242.$c_Lio_intela_sites_intelacloud_Page$$anon$2("Terms", 2);
  $t_Lio_intela_sites_intelacloud_Page$__Disclaimer = new $j_io$002eintela$002esites$002eintelacloud$002e$002dPage$0024$0024anon$00242.$c_Lio_intela_sites_intelacloud_Page$$anon$2("Disclaimer", 3);
  $t_Lio_intela_sites_intelacloud_Page$__NotFound = new $j_io$002eintela$002esites$002eintelacloud$002e$002dPage$0024$0024anon$00242.$c_Lio_intela_sites_intelacloud_Page$$anon$2("NotFound", 4);
  $s_Lio_intela_sites_intelacloud_Page$__Home__Lio_intela_sites_intelacloud_Page();
  $s_Lio_intela_sites_intelacloud_Page$__Privacy__Lio_intela_sites_intelacloud_Page();
  $s_Lio_intela_sites_intelacloud_Page$__Terms__Lio_intela_sites_intelacloud_Page();
  $s_Lio_intela_sites_intelacloud_Page$__Disclaimer__Lio_intela_sites_intelacloud_Page();
  $s_Lio_intela_sites_intelacloud_Page$__NotFound__Lio_intela_sites_intelacloud_Page();
  this.gc = new $c_Lio_intela_sites_intelacloud_Page$$anon$1();
}
export { $c_Lio_intela_sites_intelacloud_Page$ as $c_Lio_intela_sites_intelacloud_Page$ };
$p = $c_Lio_intela_sites_intelacloud_Page$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_Page$;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_Page$() {
}
export { $h_Lio_intela_sites_intelacloud_Page$ as $h_Lio_intela_sites_intelacloud_Page$ };
$h_Lio_intela_sites_intelacloud_Page$.prototype = $p;
var $d_Lio_intela_sites_intelacloud_Page$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_Page$, "io.intela.sites.intelacloud.Page$", ({
  eG: 1,
  U: 1,
  aq: 1
}));
export { $d_Lio_intela_sites_intelacloud_Page$ as $d_Lio_intela_sites_intelacloud_Page$ };
var $n_Lio_intela_sites_intelacloud_Page$;
function $m_Lio_intela_sites_intelacloud_Page$() {
  if ((!$n_Lio_intela_sites_intelacloud_Page$)) {
    $n_Lio_intela_sites_intelacloud_Page$ = new $c_Lio_intela_sites_intelacloud_Page$();
  }
  return $n_Lio_intela_sites_intelacloud_Page$;
}
export { $m_Lio_intela_sites_intelacloud_Page$ as $m_Lio_intela_sites_intelacloud_Page$ };
var $t_Lio_intela_sites_intelacloud_Page$__Home = null;
function $u_Lio_intela_sites_intelacloud_Page$__Home(x) {
  $t_Lio_intela_sites_intelacloud_Page$__Home = x;
}
export { $t_Lio_intela_sites_intelacloud_Page$__Home as $t_Lio_intela_sites_intelacloud_Page$__Home, $u_Lio_intela_sites_intelacloud_Page$__Home as $u_Lio_intela_sites_intelacloud_Page$__Home };
var $t_Lio_intela_sites_intelacloud_Page$__Privacy = null;
function $u_Lio_intela_sites_intelacloud_Page$__Privacy(x) {
  $t_Lio_intela_sites_intelacloud_Page$__Privacy = x;
}
export { $t_Lio_intela_sites_intelacloud_Page$__Privacy as $t_Lio_intela_sites_intelacloud_Page$__Privacy, $u_Lio_intela_sites_intelacloud_Page$__Privacy as $u_Lio_intela_sites_intelacloud_Page$__Privacy };
var $t_Lio_intela_sites_intelacloud_Page$__Terms = null;
function $u_Lio_intela_sites_intelacloud_Page$__Terms(x) {
  $t_Lio_intela_sites_intelacloud_Page$__Terms = x;
}
export { $t_Lio_intela_sites_intelacloud_Page$__Terms as $t_Lio_intela_sites_intelacloud_Page$__Terms, $u_Lio_intela_sites_intelacloud_Page$__Terms as $u_Lio_intela_sites_intelacloud_Page$__Terms };
var $t_Lio_intela_sites_intelacloud_Page$__Disclaimer = null;
function $u_Lio_intela_sites_intelacloud_Page$__Disclaimer(x) {
  $t_Lio_intela_sites_intelacloud_Page$__Disclaimer = x;
}
export { $t_Lio_intela_sites_intelacloud_Page$__Disclaimer as $t_Lio_intela_sites_intelacloud_Page$__Disclaimer, $u_Lio_intela_sites_intelacloud_Page$__Disclaimer as $u_Lio_intela_sites_intelacloud_Page$__Disclaimer };
var $t_Lio_intela_sites_intelacloud_Page$__NotFound = null;
function $u_Lio_intela_sites_intelacloud_Page$__NotFound(x) {
  $t_Lio_intela_sites_intelacloud_Page$__NotFound = x;
}
export { $t_Lio_intela_sites_intelacloud_Page$__NotFound as $t_Lio_intela_sites_intelacloud_Page$__NotFound, $u_Lio_intela_sites_intelacloud_Page$__NotFound as $u_Lio_intela_sites_intelacloud_Page$__NotFound };
//# sourceMappingURL=io.intela.sites.intelacloud.-Page$.js.map
